<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueApexCharts from 'vue-apexcharts';
import Swal from '@/utils/ugm-swal';

export default {
    components: { Layout, PageHeader, apexchart: VueApexCharts },
    data() {
        return {
            title: "Análisis",
            items: [{ text: "Inicio", href: "/" }, { text: "Análisis", active: true }],
            user: JSON.parse(document.querySelector('meta[name="user"]')?.content || '{}'),
            isLoading: true,
            kpis: {},
            eventosPorEstado: [],
            eventosPorTipo: [],
            eventosPorMes: [],
            colegiosPorRegion: [],
            coordinadoresMasActivos: [],
            gastosPorMes: [],
            proximosDetalle: [],
            ultimosEventos: [],
            asistentesFuentes: [],
            asistentesDetalleEventos: [],
            preferencias1Contactos: [],
            preferencias2Contactos: [],
            mostrarDesgloseAsistentes: false,
        };
    },
    computed: {
        preferencias1Top() {
            return (this.preferencias1Contactos || []).slice(0, 10);
        },
        preferencias2Top() {
            return (this.preferencias2Contactos || []).slice(0, 10);
        },
        // Gráfico: Eventos por mes (barras)
        chartEventosMes() {
            return {
                series: [{ name: 'Eventos', data: this.eventosPorMes.map(m => m.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#252C5F'],
                    plotOptions: { bar: { borderRadius: 4, columnWidth: '55%' } },
                    xaxis: {
                        categories: this.eventosPorMes.map(m => this.formatMes(m.mes)),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { style: { fontSize: '11px' } }, tickAmount: 4 },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#fff'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' eventos' } }
                }
            };
        },
        // Gráfico: Eventos por estado (donut)
        chartEstados() {
            return {
                series: this.eventosPorEstado.map(e => e.total),
                options: {
                    chart: { type: 'donut', fontFamily: 'inherit' },
                    colors: ['#252C5F', '#27ae60', '#e74c3c', '#CB9700', '#61B7E4', '#95a5a6'],
                    labels: this.eventosPorEstado.map(e => e.estado || 'Sin estado'),
                    legend: { position: 'bottom', fontSize: '11px' },
                    dataLabels: { enabled: true, style: { fontSize: '11px' } },
                    plotOptions: { pie: { donut: { size: '60%' } } },
                    tooltip: { y: { formatter: v => v + ' eventos' } }
                }
            };
        },
        // Gráfico: Eventos por tipo (barras horizontal)
        chartTipos() {
            return {
                series: [{ name: 'Eventos', data: this.eventosPorTipo.map(t => t.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#61B7E4'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
                    xaxis: { categories: this.eventosPorTipo.map(t => t.tipo || 'Sin tipo'), labels: { style: { fontSize: '11px' } } },
                    yaxis: { labels: { style: { fontSize: '11px' } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' eventos' } }
                }
            };
        },
        // Gráfico: Coordinadores más activos (barras)
        chartCoordinadores() {
            return {
                series: [{ name: 'Eventos', data: this.coordinadoresMasActivos.map(c => c.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#CB9700'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
                    xaxis: {
                        categories: this.coordinadoresMasActivos.map(c => c.coordinador_evento || 'Sin asignar'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { style: { fontSize: '11px' } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' eventos' } }
                }
            };
        },
        // Gráfico: Gastos por mes (área)
        chartGastos() {
            return {
                series: [{ name: 'Gastos', data: this.gastosPorMes.map(g => Number(g.total_monto) || 0) }],
                options: {
                    chart: { type: 'area', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#252C5F'],
                    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.05 } },
                    stroke: { curve: 'smooth', width: 2 },
                    xaxis: { categories: this.gastosPorMes.map(g => this.formatMes(g.mes)), labels: { style: { fontSize: '11px' } } },
                    yaxis: { labels: { formatter: v => '$' + Number(v).toLocaleString('es-CL'), style: { fontSize: '11px' } } },
                    dataLabels: { enabled: false },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => '$' + Number(v).toLocaleString('es-CL') } }
                }
            };
        },
        // Gráfico: Colegios por región (barras)
        chartRegiones() {
            return {
                series: [{ name: 'Eventos', data: this.colegiosPorRegion.map(r => r.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#252C5F'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
                    xaxis: {
                        categories: this.colegiosPorRegion.map(r => r.region || 'Sin comuna'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { style: { fontSize: '10px', maxWidth: 130 } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#fff'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' eventos' } }
                }
            };
        },
        // Gráfico: Preferencia 1 de contactos asociados
        chartPreferencias1() {
            return {
                series: [{ name: 'Contactos', data: this.preferencias1Top.map(p => p.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#8e44ad'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: this.preferencias1Top.map(p => p.preferencia || 'Sin preferencia'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { maxWidth: 180, trim: true, style: { fontSize: '11px' } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' contactos' } }
                }
            };
        },
        // Gráfico: Preferencia 2 de contactos asociados
        chartPreferencias2() {
            return {
                series: [{ name: 'Contactos', data: this.preferencias2Top.map(p => p.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#16a085'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: this.preferencias2Top.map(p => p.preferencia || 'Sin preferencia'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { maxWidth: 180, trim: true, style: { fontSize: '11px' } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' contactos' } }
                }
            };
        },
    },
    mounted() {
        if (!this.puedeVerAnalisis()) {
            window.location.href = '/';
            return;
        }
        this.cargar();
    },
    methods: {
        puedeVerAnalisis() {
            return ['1', '2'].includes(String(this.user && this.user.id ? this.user.id : ''))
                || this.user.rol === 'SuperAdmin'
                || this.user.rol === 'Admin';
        },
        cargar() {
            this.isLoading = true;
            axios.get('/api/get_analisis').then(res => {
                if (res.data.estado) {
                    this.kpis                    = res.data.kpis;
                    this.eventosPorEstado        = res.data.eventos_por_estado;
                    this.eventosPorTipo          = res.data.eventos_por_tipo;
                    this.eventosPorMes           = res.data.eventos_por_mes;
                    this.colegiosPorRegion       = res.data.colegios_por_region;
                    this.coordinadoresMasActivos = res.data.coordinadores_mas_activos;
                    this.gastosPorMes            = res.data.gastos_por_mes;
                    this.proximosDetalle         = res.data.proximos_detalle;
                    this.ultimosEventos          = res.data.ultimos_eventos;
                    this.asistentesFuentes       = res.data.asistentes_fuentes || [];
                    this.asistentesDetalleEventos = res.data.asistentes_detalle_eventos || [];
                    this.preferencias1Contactos  = res.data.preferencias_1_contactos || [];
                    this.preferencias2Contactos  = res.data.preferencias_2_contactos || [];
                }
            }).catch(() => {
                Swal.fire({ icon: 'error', title: 'Error al cargar métricas', timer: 3000, showConfirmButton: false });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        formatMes(mes) {
            if (!mes) return '';
            const [año, m] = mes.split('-');
            const nombres = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
            return `${nombres[parseInt(m)]} ${año}`;
        },
        formatFecha(fecha) {
            if (!fecha) return '—';
            return new Date(fecha + 'T00:00:00').toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
        },
        formatMonto(v) {
            if (!v) return '$0';
            return '$' + Number(v).toLocaleString('es-CL');
        },
        colorEstado(estado) {
            const e = (estado || '').toLowerCase();
            if (e.includes('cancel'))  return '#e74c3c';
            if (e.includes('finaliz') || e.includes('cerr')) return '#27ae60';
            if (e.includes('activ'))   return '#252C5F';
            if (e.includes('suspend') || e.includes('pospon')) return '#CB9700';
            return '#61B7E4';
        },
        ver_evento(codigo) {
            localStorage.setItem('evento_codigo', codigo);
            window.location.href = '/web/configuracion/eventos';
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <!-- Loading -->
        <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border" style="color:#252C5F; width:2.5rem; height:2.5rem;" role="status"></div>
            <p class="mt-3 text-muted">Cargando métricas...</p>
        </div>

        <div v-else>

            <!-- ── KPIs ── -->
            <div class="row mb-4">
                <!-- Eventos totales -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #252C5F;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Total Eventos</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ kpis.total_eventos }}</h3>
                                    <small class="text-muted">{{ kpis.eventos_mes_actual }} este mes</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(37,44,95,.1);">
                                    <i class="bx bx-calendar font-size-22" style="color:#252C5F;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Simulaciones -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #9b59b6;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Simulaciones</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#9b59b6;">{{ kpis.total_simulaciones ?? 0 }}</h3>
                                    <small class="text-muted">actividades simulador</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(155,89,182,.12);">
                                    <i class="bx bx-line-chart font-size-22" style="color:#9b59b6;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fichas digitalizadas -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #27ae60;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Fichas Digitalizadas</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#27ae60;">{{ kpis.fichas_digitalizadas }}</h3>
                                    <small class="text-muted">{{ kpis.fichas_mes_actual }} este mes</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(39,174,96,.1);">
                                    <i class="bx bx-file font-size-22" style="color:#27ae60;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Contactos asociados a eventos -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #8e44ad;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Contactos Asociados</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#8e44ad;">{{ kpis.total_contactos_asociados_eventos ?? kpis.total_asistentes ?? 0 }}</h3>
                                    <small class="text-muted">{{ kpis.contactos_asociados_eventos_mes ?? kpis.asistentes_mes ?? 0 }} este mes</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(142,68,173,.1);">
                                    <i class="bx bx-user-check font-size-22" style="color:#8e44ad;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Gastos mes -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #e74c3c;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Gastos del Mes</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#e74c3c;">{{ formatMonto(kpis.gastos_mes_actual) }}</h3>
                                    <small class="text-muted">Total: {{ formatMonto(kpis.total_gastos) }}</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(231,76,60,.1);">
                                    <i class="bx bx-money font-size-22" style="color:#e74c3c;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Colegios contactados -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #16a085;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Colegios Contactados</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#16a085;">{{ kpis.colegios_contactados_mes ?? 0 }}</h3>
                                    <small class="text-muted">con evento este mes</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(22,160,133,.1);">
                                    <i class="bx bx-buildings font-size-22" style="color:#16a085;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Usuarios -->
                <div class="col-md-3 col-6 mb-3">
                    <div class="card shadow-sm h-100" style="border-left:4px solid #2980b9;">
                        <div class="card-body py-3 px-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Usuarios</p>
                                    <h3 class="mb-0 font-weight-bold" style="color:#2980b9;">{{ kpis.total_usuarios }}</h3>
                                    <small class="text-muted">{{ kpis.total_laborantes }} laborantes</small>
                                </div>
                                <div class="rounded-circle d-flex align-items-center justify-content-center"
                                     style="width:48px;height:48px;background:rgba(41,128,185,.1);">
                                    <i class="bx bx-group font-size-22" style="color:#2980b9;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card shadow-sm mb-4">
                <div class="card-header py-3 d-flex align-items-center"
                     style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                    <i class="bx bx-table font-size-20 text-white mr-2"></i>
                    <div class="flex-grow-1">
                        <h6 class="mb-0 text-white font-weight-bold">Desglose Métrica Asistentes</h6>
                        <small class="text-white" style="opacity:.8;">Fuentes y números usados en el KPI</small>
                    </div>
                    <button class="btn btn-sm btn-light"
                            @click="mostrarDesgloseAsistentes = !mostrarDesgloseAsistentes">
                        {{ mostrarDesgloseAsistentes ? 'Ocultar' : 'Mostrar' }}
                    </button>
                </div>
                <div class="card-body" v-if="mostrarDesgloseAsistentes">
                    <div class="table-responsive mb-3" v-if="asistentesFuentes.length">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Fuente</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Mes actual</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(f, idx) in asistentesFuentes" :key="idx">
                                    <td>{{ f.fuente }}</td>
                                    <td class="text-right font-weight-bold">{{ Number(f.total || 0).toLocaleString('es-CL') }}</td>
                                    <td class="text-right">{{ Number(f.mes || 0).toLocaleString('es-CL') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" v-if="asistentesDetalleEventos.length">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Evento</th>
                                    <th style="min-width:230px;">Nombre</th>
                                    <th>Colegio</th>
                                    <th class="text-right">Local plantilla</th>
                                    <th class="text-right">Local por curso</th>
                                    <th class="text-right">HubSpot</th>
                                    <th class="text-right">Total referencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ev in asistentesDetalleEventos" :key="ev.evento_id">
                                    <td>{{ ev.codigo || ('ID ' + ev.evento_id) }}</td>
                                    <td>{{ ev.nombre_difusion || 'Sin nombre' }}</td>
                                    <td>{{ ev.colegio || '—' }}</td>
                                    <td class="text-right">{{ Number(ev.local_plantilla || 0).toLocaleString('es-CL') }}</td>
                                    <td class="text-right">{{ Number(ev.local_por_curso || 0).toLocaleString('es-CL') }}</td>
                                    <td class="text-right">{{ Number(ev.hubspot_asociados || 0).toLocaleString('es-CL') }}</td>
                                    <td class="text-right font-weight-bold">{{ Number(ev.total_referencia || 0).toLocaleString('es-CL') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="!asistentesFuentes.length && !asistentesDetalleEventos.length" class="text-muted">
                        No hay datos de desglose disponibles para el período.
                    </div>
                </div>
            </div>

            <!-- ── Gráficos fila 1 ── -->
            <div class="row mb-4">
                <!-- Eventos por mes -->
                <div class="col-md-7 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-bar-chart-alt-2 font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Eventos por Mes</h6>
                                <small class="text-white" style="opacity:.8;">Últimos 6 meses</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="eventosPorMes.length"
                                type="bar"
                                height="230"
                                :options="chartEventosMes.options"
                                :series="chartEventosMes.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
                <!-- Eventos por estado (donut) -->
                <div class="col-md-5 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-doughnut-chart font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Estado de Eventos</h6>
                                <small class="text-white" style="opacity:.8;">Distribución actual</small>
                            </div>
                        </div>
                        <div class="card-body pt-2 pb-0">
                            <apexchart v-if="eventosPorEstado.length"
                                type="donut"
                                height="250"
                                :options="chartEstados.options"
                                :series="chartEstados.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Gráficos fila 2 ── -->
            <div class="row mb-4">
                <!-- Eventos por tipo -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-list-ul font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Eventos por Tipo</h6>
                                <small class="text-white" style="opacity:.8;">Todos los registros</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="eventosPorTipo.length"
                                type="bar"
                                height="220"
                                :options="chartTipos.options"
                                :series="chartTipos.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
                <!-- Coordinadores más activos -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-user-voice font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Coordinadores más Activos</h6>
                                <small class="text-white" style="opacity:.8;">Por cantidad de eventos</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="coordinadoresMasActivos.length"
                                type="bar"
                                height="220"
                                :options="chartCoordinadores.options"
                                :series="chartCoordinadores.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Gráficos fila 3 ── -->
            <div class="row mb-4">
                <!-- Gastos por mes -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-line-chart font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Gastos por Mes</h6>
                                <small class="text-white" style="opacity:.8;">Últimos 6 meses</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="gastosPorMes.length"
                                type="area"
                                height="220"
                                :options="chartGastos.options"
                                :series="chartGastos.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin gastos registrados</div>
                        </div>
                    </div>
                </div>
                <!-- Colegios por región -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-map-alt font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Eventos por Comuna</h6>
                                <small class="text-white" style="opacity:.8;">Región Metropolitana</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="colegiosPorRegion.length"
                                type="bar"
                                height="220"
                                :options="chartRegiones.options"
                                :series="chartRegiones.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Gráficos fila 4 ── -->
            <div class="row mb-4">
                <!-- Preferencia 1 -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-bookmark-heart font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Preferencia 1</h6>
                                <small class="text-white" style="opacity:.8;">Top 10 contactos asociados a eventos</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="preferencias1Top.length"
                                type="bar"
                                height="300"
                                :options="chartPreferencias1.options"
                                :series="chartPreferencias1.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>

                <!-- Preferencia 2 -->
                <div class="col-md-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-bookmark-star font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Preferencia 2</h6>
                                <small class="text-white" style="opacity:.8;">Top 10 contactos asociados a eventos</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="preferencias2Top.length"
                                type="bar"
                                height="300"
                                :options="chartPreferencias2.options"
                                :series="chartPreferencias2.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin datos disponibles</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Tablas ── -->
            <div class="row">
                <!-- Próximos eventos (15 días) -->
                <div class="col-md-6 mb-4">
                    <div class="card shadow-sm">
                        <div class="card-header py-3 d-flex align-items-center justify-content-between"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <div class="d-flex align-items-center">
                                <i class="bx bx-time font-size-20 text-white mr-2"></i>
                                <div>
                                    <h6 class="mb-0 text-white font-weight-bold">Próximos Eventos</h6>
                                    <small class="text-white" style="opacity:.8;">Próximos 15 días</small>
                                </div>
                            </div>
                            <span class="badge" style="background:rgba(255,255,255,.2);color:#fff;border-radius:20px;padding:4px 10px;">
                                {{ proximosDetalle.length }}
                            </span>
                        </div>
                        <div class="card-body p-0">
                            <div v-if="proximosDetalle.length" style="max-height:340px;overflow-y:auto;">
                                <table class="table table-sm table-hover mb-0">
                                    <thead style="background:#f8f9fc;">
                                        <tr>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Actividad</th>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Fecha</th>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="ev in proximosDetalle" :key="ev.codigo"
                                            style="cursor:pointer;" @click="ver_evento(ev.codigo)">
                                            <td class="py-2 px-3">
                                                <p class="mb-0 font-size-12 font-weight-semibold" style="color:#252C5F;">{{ ev.nombre_difusion }}</p>
                                                <small class="text-muted">{{ ev.colegio }}</small>
                                            </td>
                                            <td class="py-2 px-3 font-size-12 text-nowrap">{{ formatFecha(ev.fecha_inicio) }}</td>
                                            <td class="py-2 px-3">
                                                <span class="badge font-size-10"
                                                      :style="`background:${colorEstado(ev.estado_actividad)};color:#fff;border-radius:10px;padding:3px 8px;`">
                                                    {{ ev.estado_actividad || 'Sin estado' }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-center py-4 text-muted font-size-13">
                                <i class="bx bx-calendar-x font-size-28 d-block mb-2" style="color:#CB9700;"></i>
                                No hay eventos en los próximos 15 días
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Últimos eventos registrados -->
                <div class="col-md-6 mb-4">
                    <div class="card shadow-sm">
                        <div class="card-header py-3 d-flex align-items-center justify-content-between"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <div class="d-flex align-items-center">
                                <i class="bx bx-history font-size-20 text-white mr-2"></i>
                                <div>
                                    <h6 class="mb-0 text-white font-weight-bold">Últimos Eventos Creados</h6>
                                    <small class="text-white" style="opacity:.8;">Más recientes</small>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div v-if="ultimosEventos.length" style="max-height:340px;overflow-y:auto;">
                                <table class="table table-sm table-hover mb-0">
                                    <thead style="background:#f8f9fc;">
                                        <tr>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Actividad</th>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Inicio</th>
                                            <th class="font-size-11 text-uppercase py-2 px-3" style="color:#252C5F;">Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="ev in ultimosEventos" :key="ev.codigo"
                                            style="cursor:pointer;" @click="ver_evento(ev.codigo)">
                                            <td class="py-2 px-3">
                                                <p class="mb-0 font-size-12 font-weight-semibold" style="color:#252C5F;">{{ ev.nombre_difusion }}</p>
                                                <small class="text-muted">{{ ev.colegio }}</small>
                                            </td>
                                            <td class="py-2 px-3 font-size-12 text-nowrap">{{ formatFecha(ev.fecha_inicio) }}</td>
                                            <td class="py-2 px-3">
                                                <span class="badge font-size-10"
                                                      :style="`background:${colorEstado(ev.estado_actividad)};color:#fff;border-radius:10px;padding:3px 8px;`">
                                                    {{ ev.estado_actividad || 'Sin estado' }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-center py-4 text-muted font-size-13">Sin registros</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </Layout>
</template>

<style scoped>
.card { border: none; border-radius: 8px; }
.card-header { border-bottom: none; }
</style>
